<div class="upSlider update" [class.show]="showUpdate">
    <div class="box" *ngIf="updateStep1">
        <div class="slider-box">
            <div class="slider-header">
                <div (click)="closePopup()">
                    <img src="assets/img/gray-down-arrow.svg" alt="">
                </div>
                <div class="top-update">
                    <img  style="max-height: 50px;" src="assets/img/direct-download.svg" alt="">
                    <span class="app-version"> نسخه <i>{{appDetail?.newestAvailableVersion}}</i></span>
                    <h1 class="header1">بروز رسانی به آخرین نسخه همراه نوین</h1>
                    <h3 class="header3">نسخه جدید همراه نوین منتشر شد</h3>
                </div>
            </div>
            <div class="slider-box-body">
                <h3 *ngIf="appDetail?.features" class="header3">تغییرات نسخه جدید :</h3>
                <ul>
                    <li *ngFor="let item of appDetail?.features">
                        <span class="purpleDot"></span>
                        {{item}}
                    </li>
                </ul>
                <div class="btnContainer">
                    <button class="btn purpleBtn" style="width: 64%;" (click)="updateApp()">دریافت نسخه جدید</button>
                    <button class="btn" style="width: 33%;" (click)="closePopup()">بعدا بروز می کنم</button>
                </div>
            </div>
        </div>
    </div>
    <div class="box" *ngIf="!updateStep1">
        <div class="slider-box">
            <div class="slider-header">
                <div (click)="closePopup()">
                    <img src="assets/img/gray-down-arrow.svg" alt="">
                </div>
                <div class="top-update">
                    <img src="assets/img/novin-box.svg" alt="">
                    <h1 class="header1">همراه نوین نسخه <i>{{appDetail?.newestAvailableVersion}}</i> </h1>
                    <h3 class="header3">شما از آخرین نسخه همراه نوین استفاده می‌کنید</h3>
                </div>
            </div>
            <div class="slider-box-body">
                <h3 *ngIf="appDetail?.features" class="header3">  امکانات نسخه <i>{{appDetail?.newestAvailableVersion}}</i> : </h3>
                <ul>
                    <li *ngFor="let item of appDetail?.features">
                        <span class="purpleDot"></span>
                        {{item}}
                    </li>
                </ul>
                <button class="btn purpleBtn" (click)="closePopup()">متوجه شدم</button>
            </div>
        </div>
    </div>
  </div>